const menuList = [
    {
        path: '/bigScreen',
        name: '大屏',
        component: () => import('@/views/bigScreen')
    },
    {
        path: "/webgl",
        name: "3D",
        component: () => import('@/views/webgl')
    },
    {
        path: "/canvasEffect",
        name: "特效",
        component: () => import('@/views/canvasEffect')
    },
    {
        path: "/siteCollect",
        name: "站点",
        component: () => import('@/views/siteCollect')
    },
    // {
    //     path: "/worm",
    //     name: "爬虫",
    //     component: () => import('@/views/worm')
    // },
    {
        path: "/otherSundry",
        name: "其它",
        component: () => import('@/views/otherSundry')
    },
]

export default menuList;